/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FilterOptionsList,
  GameMission,
  GameMissions,
  GameMissionsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Missions list
 */
export const gameMissions = (
    params?: MaybeRefOrGetter<GameMissionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<GameMissions>(
      {url: `/missions`, method: 'GET',
        params, signal
    },
      );
    }




export const getGameMissionsQueryKey = (params?: MaybeRefOrGetter<GameMissionsParams>,) => {
    return [
    'missions', ...(params ? [params] : [])
    ] as const;
    }


export const getGameMissionsQueryOptions = <TData = Awaited<ReturnType<typeof gameMissions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<GameMissionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMissions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGameMissionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gameMissions>>> = ({ signal }) => gameMissions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gameMissions>>, TError, TData>
}

export type GameMissionsQueryResult = NonNullable<Awaited<ReturnType<typeof gameMissions>>>
export type GameMissionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Missions list
 */

export function useGameMissions<TData = Awaited<ReturnType<typeof gameMissions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<GameMissionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMissions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGameMissionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Mission orgs
 */
export const gameMissionOrgs = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/missions/org_filters`, method: 'GET', signal
    },
      );
    }




export const getGameMissionOrgsQueryKey = () => {
    return [
    'missions','org_filters'
    ] as const;
    }


export const getGameMissionOrgsQueryOptions = <TData = Awaited<ReturnType<typeof gameMissionOrgs>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMissionOrgs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGameMissionOrgsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gameMissionOrgs>>> = ({ signal }) => gameMissionOrgs(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gameMissionOrgs>>, TError, TData>
}

export type GameMissionOrgsQueryResult = NonNullable<Awaited<ReturnType<typeof gameMissionOrgs>>>
export type GameMissionOrgsQueryError = ErrorType<StandardError>


/**
 * @summary Mission orgs
 */

export function useGameMissionOrgs<TData = Awaited<ReturnType<typeof gameMissionOrgs>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMissionOrgs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGameMissionOrgsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Mission reward kinds
 */
export const gameMissionRewardKinds = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/missions/reward_kind_filters`, method: 'GET', signal
    },
      );
    }




export const getGameMissionRewardKindsQueryKey = () => {
    return [
    'missions','reward_kind_filters'
    ] as const;
    }


export const getGameMissionRewardKindsQueryOptions = <TData = Awaited<ReturnType<typeof gameMissionRewardKinds>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMissionRewardKinds>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGameMissionRewardKindsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gameMissionRewardKinds>>> = ({ signal }) => gameMissionRewardKinds(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gameMissionRewardKinds>>, TError, TData>
}

export type GameMissionRewardKindsQueryResult = NonNullable<Awaited<ReturnType<typeof gameMissionRewardKinds>>>
export type GameMissionRewardKindsQueryError = ErrorType<StandardError>


/**
 * @summary Mission reward kinds
 */

export function useGameMissionRewardKinds<TData = Awaited<ReturnType<typeof gameMissionRewardKinds>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMissionRewardKinds>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGameMissionRewardKindsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Mission standings
 */
export const gameMissionStandings = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/missions/standing_filters`, method: 'GET', signal
    },
      );
    }




export const getGameMissionStandingsQueryKey = () => {
    return [
    'missions','standing_filters'
    ] as const;
    }


export const getGameMissionStandingsQueryOptions = <TData = Awaited<ReturnType<typeof gameMissionStandings>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMissionStandings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGameMissionStandingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gameMissionStandings>>> = ({ signal }) => gameMissionStandings(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gameMissionStandings>>, TError, TData>
}

export type GameMissionStandingsQueryResult = NonNullable<Awaited<ReturnType<typeof gameMissionStandings>>>
export type GameMissionStandingsQueryError = ErrorType<StandardError>


/**
 * @summary Mission standings
 */

export function useGameMissionStandings<TData = Awaited<ReturnType<typeof gameMissionStandings>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMissionStandings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGameMissionStandingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Mission Detail
 */
export const gameMission = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<GameMission>(
      {url: `/missions/${id}`, method: 'GET', signal
    },
      );
    }




export const getGameMissionQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'missions',id
    ] as const;
    }


export const getGameMissionQueryOptions = <TData = Awaited<ReturnType<typeof gameMission>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMission>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGameMissionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gameMission>>> = ({ signal }) => gameMission(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gameMission>>, TError, TData>
}

export type GameMissionQueryResult = NonNullable<Awaited<ReturnType<typeof gameMission>>>
export type GameMissionQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Mission Detail
 */

export function useGameMission<TData = Awaited<ReturnType<typeof gameMission>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMission>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGameMissionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






